import styled from 'react-emotion';
import { Link } from 'react-router-dom';

export const Next = styled(Link)`
  display: inline-block;
  font-size: 0.85rem;
  text-decoration: none;
  font-weight: bold;
  color: #333;
  padding: 0.5rem 1rem;
  background: #efefef;
  border: 1px solid #dfdfdf;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  -ms-border-radius: 0;
  border-radius: 0;
  max-width: 100px;
  flex: 1 1 auto;
  width: 100%;
  text-align: center;

  &:disabled {
    opacity: 0.5;
  }

  &:hover {
    background: #dadada;
  }
`;

export const Prev = styled(Next)`
  /* transform: rotate(90deg); */
`;
